const TYPES = {
    GET_PAYOUT_REPORT: 'GET_PAYOUT_REPORT',
    GET_PAYOUT_REPORT_COMPLETE: 'GET_PAYOUT_REPORT_COMPLETE',
    GET_PAYOUT_REPORT_FAILED: 'GET_PAYOUT_REPORT_FAILED',

    TRACE_SECURITY_LINK: 'TRACE_SECURITY_LINK',

    SET_PAYOUT_DATE: 'SET_PAYOUT_DATE',

    GET_PAYOUT_REPORT_LIST: 'GET_PAYOUT_REPORT_LIST',
    GET_PAYOUT_REPORT_LIST_COMPLETE: 'GET_PAYOUT_REPORT_LIST_COMPLETE',
    GET_PAYOUT_REPORT_LIST_FAILED: 'GET_PAYOUT_REPORT_LIST_FAILED',
    RESET_REPORT_LIST_PAGANTION: 'RESET_REPORT_LIST_PAGANTION',
    GET_PAYOUT_REPORT_DETAIL: 'GET_PAYOUT_REPORT_DETAIL',
    GET_PAYOUT_REPORT_DETAIL_COMPLETE: 'GET_PAYOUT_REPORT_DETAIL_COMPLETE',
    GET_PAYOUT_REPORT_DETAIL_FAILED: 'GET_PAYOUT_REPORT_DETAIL_FAILED',

    GET_PAYOUT_ACCEPTANCE: 'GET_PAYOUT_ACCEPTANCE',
    GET_PAYOUT_ACCEPTANCE_SUCCESS: 'GET_PAYOUT_ACCEPTANCE_SUCCESS',
    GET_PAYOUT_ACCEPTANCE_FAILED: 'GET_PAYOUT_ACCEPTANCE_FAILED',

    GET_PAYABLE_AMOUNTS: 'GET_PAYABLE_AMOUNTS',
    GET_PAYABLE_AMOUNTS_SUCCESS: 'GET_PAYABLE_AMOUNTS_SUCCESS',
    GET_PAYABLE_AMOUNTS_FAILED: 'GET_PAYABLE_AMOUNTS_FAILED',

    GET_OFFLINE_PAYMENT: 'GET_OFFLINE_PAYMENT',
    GET_OFFLINE_PAYMENT_SUCCESS: 'GET_OFFLINE_PAYMENT_SUCCESS',
    GET_OFFLINE_PAYMENT_FAILED: 'GET_OFFLINE_PAYMENT_FAILED',

    SAVE_OFFLINE_PAYMENT: 'SAVE_OFFLINE_PAYMENT',
    SAVE_OFFLINE_PAYMENT_SUCCESS: 'SAVE_OFFLINE_PAYMENT_SUCCESS',
    SAVE_OFFLINE_PAYMENT_FAILED: 'SAVE_OFFLINE_PAYMENT_FAILED'
};

export default {
    TYPES,

    getPayoutReport: payload => ({
        type: TYPES.GET_PAYOUT_REPORT,
        payload
    }),

    getPayoutReportSuccess: payload => ({
        type: TYPES.GET_PAYOUT_REPORT_COMPLETE,
        payload
    }),

    getPayoutReportFailed: payload => ({
        type: TYPES.GET_PAYOUT_REPORT_FAILED,
        payload
    }),

    setPayoutDate: payload => ({
        type: TYPES.SET_PAYOUT_DATE,
        payload
    }),

    getPayoutReportList: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_LIST
    }),

    getPayoutReportListSuccess: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_LIST_COMPLETE
    }),

    getPayoutReportListFailed: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_LIST_FAILED
    }),

    resetReportListPaganiton: () => ({
        type: TYPES.RESET_REPORT_LIST_PAGANTION
    }),

    getPayoutReportDetail: payload => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_DETAIL
    }),

    getPayoutReportDetailSuccess: payload => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_DETAIL_COMPLETE
    }),

    getPayoutReportDetailFailed: payload => ({
        payload,
        type: TYPES.GET_PAYOUT_REPORT_DETAIL_FAILED
    }),

    getPayoutAcceptance: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_ACCEPTANCE
    }),

    getPayoutAcceptanceSuccess: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_ACCEPTANCE_SUCCESS
    }),

    getPayoutAcceptanceFailed: (payload?) => ({
        payload,
        type: TYPES.GET_PAYOUT_ACCEPTANCE_FAILED
    }),

    getPayableAmounts: payload => ({
        payload,
        type: TYPES.GET_PAYABLE_AMOUNTS
    }),

    getPayableAmountsSuccess: payload => ({
        payload,
        type: TYPES.GET_PAYABLE_AMOUNTS_SUCCESS
    }),

    getPayableAmountsFailed: payload => ({
        payload,
        type: TYPES.GET_PAYABLE_AMOUNTS_FAILED
    }),

    getOffilePayment: (payload?) => ({
        payload,
        type: TYPES.GET_OFFLINE_PAYMENT
    }),

    getOffilePaymentSuccess: (payload?) => ({
        payload,
        type: TYPES.GET_OFFLINE_PAYMENT_SUCCESS
    }),

    getOffilePaymentFailed: (payload?) => ({
        payload,
        type: TYPES.GET_OFFLINE_PAYMENT_FAILED
    }),

    saveOfflinePayment: payload => ({
        payload,
        type: TYPES.SAVE_OFFLINE_PAYMENT
    }),

    saveOfflinePaymentSuccess: payload => ({
        payload,
        type: TYPES.SAVE_OFFLINE_PAYMENT_SUCCESS
    }),

    saveOfflinePaymentFailed: payload => ({
        payload,
        type: TYPES.SAVE_OFFLINE_PAYMENT_FAILED
    }),

    traceSecurityLink: () => ({
        type: TYPES.TRACE_SECURITY_LINK
    })
};
